module.exports = __webpack_public_path__ + "img/edit.a59a223e.svg";